import { useEffect, useState } from "react";
import { BpmService } from "../../../core/services/BpmService";
import { _Inbox, _ItemFlow } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { CardTaps } from "../../theme/Component/CardTaps";
import { FaBan, FaCheckCircle, FaClock } from "react-icons/fa";
import { ProcedureActionInbox } from "./ProcedureActionInbox";
import { BasicButton } from "../../theme/Component/BasicButton";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { MyEditor } from "../../theme/Component/MyEditor";
import { PersonalHistory } from "./PersonalHistory";
import { PrintJson } from "../../theme/Component/PrintJson";
import usePaginator from "../../theme/Component/usePaginator";
import { AccountEditor } from "../../editor/AccountEditor";
import { BasicPage } from "../../theme/Component/BasicPage";


interface Procedure {
    IDProcedureImp: number;
    AlphaCode: string;
    ProcedureName: string;
}
interface Props {
    FilterCode?: string;
    admin?: boolean;
}

export const PerosnalInbox = ({ FilterCode, admin }: Props) => {

    const _single = Singleton.getInstance();
    const { instance } = useDataBean(_Inbox);
    const service = new BpmService();
    const [lista, setLista] = useState<any>();
    const [bean, setBean] = useState<Procedure>({ IDProcedureImp: 0, AlphaCode: "", ProcedureName: "" });
    const [description, setDescription] = useState<string>("");
    const [modalHistory, setModalHistory] = useState<any>({ name: 'Historial', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalConfirm, setModalConfirm] = useState<any>({ name: 'Cancelar Procedimiento', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [states, setstates] = useState<any>([]);
    const paginador = usePaginator();
    const [filter, setFilter] = useState<any>({
        IDAccount: _single.getAccountID(),
        State: 0
    });


    useEffect(() => {
        // getLista();
        getProcedureImpConstants();
    }, [])
    useEffect(() => {
        getLista()
    }, [paginador.page, filter])

    const getLista = () => {
        _single.spinner(true)

        let f = { ...filter };
        if (FilterCode) {
            f.BusinessCode = `=${FilterCode}`;
        }
        service.getProcedureImpRender(paginador.page, 15, f, []).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    let data = resp.DataBeanProperties.ObjectValue.DataBeanProperties;
                    console.log(data);

                    setLista(data.List);
                    paginador.setPages(data.NumberOfPages);
                } else if (resp.DataBeanProperties.ErrorMessage) {
                    toast.error(resp.DataBeanProperties.ErrorMessage)
                }
                else {
                    toast.success("No tiene tareas pendientes")
                }
                _single.spinner(false)
            }
        )
    }
    const getProcedureImpConstants = () => {
        _single.spinner(true)

        service.getProcedureImpConstants(0).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {


                    setstates(resp.DataBeanProperties.ObjectValue);
                }
                _single.spinner(false)
            }
        )
    }

    const deleteProcedureImp = () => {
        _single.spinner(true);
        service.cancelProcedureImp(bean.IDProcedureImp, _single.getAccountID(), description).subscribe(
            (resp: any) => {
                if (resp) {
                    toast.success("Se ha realizado la accion");
                    getLista();
                    setModalConfirm({ ...modalConfirm, "view": false });
                    pushResumeInfo(description);
                }
                _single.spinner(false);
            }
        )
    }

    const pushResumeInfo = (objeto: any) => {
        console.log(bean)
        instance.pushResumeBpm(bean.IDProcedureImp, _single.getAccountID(), `${objeto} - Paso de Cancelación: ${bean.ProcedureName}`, { disableSpinner: true }).then(
            (resp) => {
                setDescription("");
            }
        ).catch(err => { console.log("Error en actualizar la tabla", err) })
    }

    const taps = [
        { id: 0, name: 'Solicitudes' },
        { id: 1, name: 'Pendientes' }
    ]
    const [indexTap, setIndexTap] = useState(0);

    return (
        <BasicPage titulo="Bandeja Personal">
            <div className="row">
                {admin &&
                    <div className="col-md-12">
                        <AccountEditor idAccount={filter.IDAccount} label="Usuario a consultar" onChange={(e) => { setFilter({ ...filter, IDAccount: e.IDAccount }) }} />
                    </div>
                }
                <div className="col-md-12">
                    <CardTaps taps={taps} index={indexTap} updateIndex={setIndexTap} >
                        {indexTap === 0 &&
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Estado</label>
                                            <select className="form-select" value={filter.State} onChange={(e) => { setFilter({ ...filter, "State": parseInt(e.target.value) }) }}>
                                                <option value={null}>Todos</option>
                                                {states.map((e: any, i: number) => {
                                                    return <option key={i} value={e.DataBeanProperties.Property}>{e.DataBeanProperties.Value}</option>
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2    ">
                                    <div className="d-flex justify-content-between mt-3">
                                        <div>
                                            <button type="button" className="btn btn-outline-primary btn-icon waves-effect waves-light shadow-none" disabled={paginador.page === 1} onClick={() => { paginador.setPage(prev => prev - 1) }}><i className="ri-rewind-fill"></i></button>
                                        </div>
                                        <div className="mt-2">
                                            <strong>{paginador.page} de {paginador.pages}</strong>
                                        </div>
                                        <div>
                                            <button type="button" className="btn btn-outline-primary btn-icon waves-effect waves-light shadow-none" disabled={paginador.page === paginador.pages} onClick={() => { paginador.setPage(prev => prev + 1) }}><i className="ri-speed-fill"></i></button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th >Solicitud</th>
                                                <th >Solicitante</th>
                                                <th >Formulario / Tarea</th>
                                                <th >Acciones</th>
                                                {filter.State === 2 &&
                                                    <th >Cancelado</th>

                                                }
                                            </tr>
                                        </thead>
                                        {lista &&
                                            <>
                                                <tbody>
                                                    {lista.map((e: any, i: number) =>
                                                        <tr
                                                            key={i}
                                                        >
                                                            <th scope="row">
                                                                <p>
                                                                    <span className="text-primary">{e.DataBeanProperties.AlphaCode}</span><br />
                                                                    <small>{e.DataBeanProperties.Since}</small><br />
                                                                    <small>{e.DataBeanProperties.StateName}</small><br />
                                                                </p>
                                                            </th>
                                                            <th scope="row">
                                                                <p>
                                                                    {e.DataBeanProperties.AccountName}<br />
                                                                    <small>{e.DataBeanProperties.Description}</small>
                                                                </p>
                                                            </th>
                                                            {/* <td><strong>{e.DataBeanProperties.StateName}</strong></td> */}
                                                            <td>
                                                                <p>
                                                                    {e.DataBeanProperties.BusinessName}<br />
                                                                    <small>
                                                                        {e.DataBeanProperties.ProcedureName}

                                                                    </small>

                                                                </p>
                                                            </td>
                                                            {filter.State === 2 &&
                                                                <th scope="row">
                                                                    <p>
                                                                        <strong>Cancelado por : </strong><br />
                                                                        <small>{e.DataBeanProperties.CancelledEmployeeName}</small>

                                                                    </p>
                                                                </th>
                                                            }

                                                            <td>
                                                                <div className="d-flex justify-content-center gap-2 mt-3 fs-2 text-warning">
                                                                    {e.DataBeanProperties.State === 0 &&
                                                                        <FaCheckCircle title='Gestionar' className="pointer" onClick={() => { setIndexTap(1); setBean(e.DataBeanProperties) }} />
                                                                    }
                                                                    <FaClock title='Historial' className="pointer" onClick={() => { setModalHistory({ ...modalHistory, "view": true }); setBean(e.DataBeanProperties) }} />
                                                                    {e.DataBeanProperties.State === 0 &&
                                                                        <FaBan title='Cancelar' className="pointer" onClick={() => { setModalConfirm({ ...modalConfirm, "view": true }); setBean(e.DataBeanProperties) }} />
                                                                    }
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </>
                                        }
                                    </table>
                                    {/* <PrintJson json={lista} /> */}
                                </div>

                            </div>
                        }
                        {indexTap === 1 &&
                            <>
                                <h3>{bean.AlphaCode}</h3>
                                <ProcedureActionInbox _idAccount={filter.IDAccount} requestLista={() => { setIndexTap(0); getLista(); }} Procedure={bean} />
                                <BasicButton icon="ri-arrow-left-fill" eventClick={() => { setIndexTap(0); getLista(); }} >Volver</BasicButton>
                            </>
                        }
                    </CardTaps>

                    <Modal modal={modalHistory} updateModal={setModalHistory}>
                        <PersonalHistory IDProcedureImp={bean.IDProcedureImp} />
                    </Modal>

                    <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={deleteProcedureImp}>
                        <p>¿Porque razon quieres cancelar el proceso?</p>
                        {/* <PrintJson json={bean} /> */}
                        <MyEditor val={description} onChange={(e: any) => { setDescription(e) }}></MyEditor>
                    </ModalConfirm>

                </div>
            </div>
        </BasicPage>
    )
}